import { render } from "./card-order.vue?vue&type=template&id=5a43ee4a"
import script from "./card-order.vue?vue&type=script&lang=js"
export * from "./card-order.vue?vue&type=script&lang=js"

import "./card-order.vue?vue&type=style&index=0&id=5a43ee4a&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__